<template>
  <el-dialog title="供应商详情" class="global-dialog" :visible.sync="showDlg" width="600px" :before-close="handleClose">

    <div class="dlg-content">
      <el-form class="global-form  " v-loading="loading" style="padding:30px 40px 20px 20px" :model="formData"
         ref="form2" label-width="120px">
        <el-row>

          <el-col :span="24">
            <el-form-item prop="supplierName" label="供应商名称">
              {{ formData.supplierName || '--' }}
            </el-form-item>

          </el-col>
          <el-col :span="24">
            <el-form-item prop="regStatus" label="报名状态">
              <el-tag type="warning" v-if="formData.regStatus == '1'">待处理</el-tag>
              <el-tag v-if="formData.regStatus == '2'">已接受</el-tag>
              <el-tag type="danger" v-if="formData.regStatus == '3'">已拒绝</el-tag>
            </el-form-item>

          </el-col>
          <el-col :span="24">
            <el-form-item prop="bidStatus" label="中标状态">
              <el-tag type="warning" v-if="formData.bidStatus == '1'">未中标</el-tag>
              <el-tag v-if="formData.bidStatus == '2'">已中标</el-tag>
              <el-tag type="danger" v-if="formData.bidStatus == '3'">已拒绝</el-tag>

            </el-form-item>

          </el-col>
          <el-col :span="24">
            <el-form-item prop="quote" label="报价(元)">
              {{ formData.quote || '--' }}

            </el-form-item>

          </el-col>
          <el-col :span="24">
            <el-form-item prop="remark" label="备注说明">
              {{ formData.remark || '--' }}

            </el-form-item>

          </el-col>
          <el-col :span="24">
            <el-form-item prop="ctime" label="创建时间">
              {{ formData.ctime || '--' }}

            </el-form-item>

          </el-col>
          <el-col :span="24">
            <el-form-item prop="fileList" label="附件列表">
              <file-upload v-model="formData.fileList" :readonly="true"></file-upload>

            </el-form-item>

          </el-col>
        </el-row>

      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
    </span>

  </el-dialog>
</template>
<script>

export default {
  props: {
    relId: {
      type: String,
      default: ''
    },
    showDlg: {
      type: Boolean,
      default: false
    }

  },
  data () {
    return {

      formData: {
        relId: '',
        bidId: '',
        supplierId: '',
        regStatus: '',
        bidStatus: null,
        quote: null,
        remark: null,
        ctime: '',
        fileList: [],
        supplierName: ''

      },
      loading: false

    }
  },
  created () {
    if (this.relId) {
      this.loadData()
    }
  },
  methods: {
    handleClose () {
      this.$emit('update:showDlg', false)
    },
    loadData () {
      this.$axios.get(this.$apis.tenderDocument.selectYcBidSupplierByRelId, {
        params: { relId: this.relId }
      }).then(res => {
        res.fileList = res.fileList ? res.fileList : []

        this.formData = res || {}
      })
    }
  }
}
</script>

<style scoped lang="scss">
.el-select {
  width: 100%;
}

.row-wrap {
  display: flex;
  flex-wrap: wrap;
}
</style>
